module.exports = __webpack_public_path__ + "static/img/10.3ee046d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/10.png
// module id = ZOtm
// module chunks = 0